import React from 'react';
import { Link } from 'react-router';
import { useApplicationContext } from '../../context/ApplicationContext';
import ApplicationLink from '../common/ApplicationLink';
import { toModernAppSectionUrl } from '../../utils/paths';
const Footer = ({ compact = false }) => {
    const year = new Date().getFullYear();
    const { application, applicationPath } = useApplicationContext();
    if (compact) {
        return (React.createElement("footer", { className: "footer wt-auth-footer" },
            React.createElement("div", { className: "container-fluid wt-auth-footer-inner" },
                React.createElement("nav", { className: "wt-auth-footer-links", "aria-label": "Wikitruth information" },
                    React.createElement(ApplicationLink, { href: applicationPath(toModernAppSectionUrl(application?.aboutUrl || '/about')) }, "About"),
                    React.createElement(Link, { to: applicationPath('/contact') }, "Contact"),
                    React.createElement(Link, { to: applicationPath('/policies') }, "Policies"),
                    React.createElement("a", { href: "https://github.com/wikitruth/wikitruth", target: "_blank", rel: "noreferrer" }, "GitHub")),
                React.createElement("span", { className: "copyright" },
                    "\u00A9 ",
                    year,
                    " Wikitruth"))));
    }
    return (React.createElement("footer", { className: "footer" },
        React.createElement("div", { className: "container-fluid wt-standard-footer-inner" },
            React.createElement("nav", { "aria-label": "Wikitruth links" },
                React.createElement("ul", { className: "links" },
                    React.createElement("li", null,
                        React.createElement(ApplicationLink, { href: application?.homeUrl || '/', className: "no-underline" },
                            React.createElement("i", { className: "fa fa-home" }),
                            React.createElement("span", { className: "hidden-xxs" }, " Home"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "https://www.facebook.com/wikitruth.project", className: "no-underline", target: "_blank", rel: "noreferrer" },
                            React.createElement("i", { className: "fa fa-facebook-official" }),
                            React.createElement("span", { className: "hidden-xxs" }, " Facebook"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "https://github.com/wikitruth/wikitruth", target: "_blank", rel: "noreferrer", className: "no-underline" },
                            React.createElement("i", { className: "fa fa-github" }),
                            React.createElement("span", { className: "hidden-xxs" }, " Source"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "https://github.com/wikitruth/wikitruth/blob/develop/LICENSE", target: "_blank", rel: "noreferrer", className: "no-underline" },
                            React.createElement("i", { className: "fa fa-balance-scale" }),
                            React.createElement("span", { className: "hidden-xs" }, " License"))),
                    React.createElement("li", null,
                        React.createElement(ApplicationLink, { href: applicationPath(toModernAppSectionUrl(application?.aboutUrl || '/about')), className: "no-underline" },
                            React.createElement("i", { className: "fa fa-info-circle" }),
                            React.createElement("span", { className: "hidden-xs" }, " About"))),
                    React.createElement("li", null,
                        React.createElement(Link, { to: applicationPath('/contact'), className: "no-underline" },
                            React.createElement("i", { className: "fa fa-comment" }),
                            React.createElement("span", { className: "hidden-xs" }, " Contact"))))),
            React.createElement("span", { className: "copyright" },
                "\u00A9 ",
                year,
                "\u00A0",
                React.createElement("a", { href: "https://github.com/wikitruth", target: "_blank", rel: "noreferrer" },
                    "Wikitruth ",
                    React.createElement("span", { className: "hidden-xs" }, "Foundation"))))));
};
export default Footer;
